// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { MaterialUiCore } from '@gscope-mfe/common-libs';

const { createTheme } = MaterialUiCore;

export const gscopeTheme = createTheme({
    typography: {
        fontFamily: '"Source Sans Pro", "sans-serif"',
        fontSize: 14,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fontWeight: 400,
        htmlFontSize: 14,
    },
    overrides: {
        MuiTooltip: {
            tooltip: {
                backgroundColor: 'var(--black)',
                fontSize: '14px',
            },
            arrow: {
                color: 'black',
            },
        },
        MuiInputBase: {
            root: {
                height: '40px',
            },
        },
        MuiInputLabel: {
            outlined: {
                transform: 'translate(14px, 10px) scale(1)',
            },
        },
        MuiToolbar: {
            regular: {
                height: '100%',
            },
        },
        MuiBreadcrumbs: {
            ol: {
                fontSize: 13,
            },
        },
        MuiAppBar: {
            root: {
                height: 24,
                backgroundColor: '#fff',
                zIndex: 1301,
            },
            colorPrimary: {
                backgroundColor: '#000',
            },
        },
        MuiInput: {
            underline: {
                '&:before': {
                    borderBottom: 0,
                },
                '&:after': {
                    borderBottom: 0,
                },
                '&:hover': {
                    '&:before': {
                        borderBottom: '0px !important',
                    },
                },
            },
        },
        MuiLinearProgress: {
            barColorPrimary: {
                backgroundColor: '#3ec5e6',
            },
        },
        MuiCircularProgress: {
            colorPrimary: {
                color: '#3ec5e6',
            },
        },
        MuiIconButton: {
            root: {
                '&:hover': {
                    backgroundColor: '#f5f5f5',
                },
            },
        },
        MuiSnackbarContent: {
            root: {
                backgroundColor: '#3a3a3a',
                borderBottomLeftRadius: '0 !important',
                borderBottomRightRadius: '0 !important',
            },
        },
        MuiCard: {
            root: {
                borderRadius: 0,
                boxShadow: 'none',
            },
        },
        MuiPaper: {
            rounded: {
                borderRadius: 0,
            },
            elevation2: {
                boxShadow: 'none',
            },
        },
        MuiTable: {
            root: {
                borderRight: '1px solid var(--dividerGray)',
                borderLeft: '1px solid var(--dividerGray)',
                '& .MTableHeader-header-217': {
                    backgroundColor: 'var(--backgroundGray)',
                },
                '& tr:nth-child(2n)': {
                    background: 'var(--lightGray)',
                },
                '& tr': {
                    borderBottom: 'none',
                },
                '& .MuiTablePagination-selectIcon': {
                    top: 10,
                },
                '& .MuiTablePagination-toolbar': {
                    borderBottom: '1px solid var(--dividerGray)',
                    borderTop: '1px solid var(--dividerGray)',
                },
            },
        },
        MuiTablePagination: {
            caption: {
                display: 'block !important',
            },
            root: {
                width: '100%',
            },
        },
        MuiTableHead: {
            root: {
                fontSize: 14,
            },
        },
        MuiTableCell: {
            root: {
                borderBottom: 'none',
                fontSize: 14,
                lineHeight: 'normal',
            },
            head: {
                lineHeight: 'normal',
                fontWeight: 'normal',
                borderTop: '1px solid var(--dividerGray)',
                borderBottom: '1px solid var(--dividerGray)',
            },
        },
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: 'var(--ctaBlue)',
            },
        },
        MuiPickersDay: {
            daySelected: {
                backgroundColor: 'var(--ctaBlue)',
                color: 'var(--white)',
                '&:hover': {
                    backgroundColor: 'var(--ctaBlueHover)',
                    color: 'var(--white)',
                },
                '&:active': {
                    backgroundColor: 'var(--ctaBluePressed)',
                    color: 'var(--white)',
                },
            },
        },
        MuiTypography: {
            subtitle1: {
                lineHeight: 2,
            },
            h6: {
                fontSize: '16px',
                fontWeight: 600,
                lineHeight: 'normal',
            },
        },
        MuiSwitch: {
            root: {
                width: 38,
                height: 18,
                padding: 0,
                display: 'flex',
            },
            colorSecondary: {
                '&$checked': {
                    color: 'var(--fashionPink)',
                    '& + $track': {
                        backgroundColor: 'var(--white)',
                        borderColor: 'var(--fashionPink)',
                    },
                },
            },
            switchBase: {
                padding: 3,
                marginLeft: 'unset !important',
                color: 'var(--neutralGray)',
                '&$checked': {
                    transform: 'translateX(20px)',
                    color: 'var(--fashionPink)',
                    '& + $track': {
                        opacity: 1,
                        backgroundColor: 'var(--white)',
                        borderColor: 'var(--fashionPink)',
                    },
                },
            },
            thumb: {
                width: 12,
                height: 12,
                boxShadow: 'none',
            },
            track: {
                border: '1px solid var(--midnightGray)',
                borderRadius: 18 / 2,
                opacity: 0.5,
                backgroundColor: 'var(--white)',
            },
            checked: {},
        },
        MuiTabs: {
            indicator: {
                backgroundColor: 'var(--fashionPink)',
            },
            flexContainer: {
                borderBottom: '1px solid var(--dividerGray)',
            },
        },
        MuiTab: {
            root: {
                textTransform: 'none',
                fontSize: '14px',
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                fontWeight: '600',
                color: 'var(--lighterBlack)',
                padding: '6px 16px',
                minWidth: '130px !important',
            },
        },
    },
    appBarHeight: {
        height: 64,
    },
    drawer: {
        width: 400,
    },
    menu: {
        maxHeight: 540,
    },
});
